import { render } from "./InterestAllies.vue?vue&type=template&id=3f069ab6&scoped=true"
import script from "./InterestAllies.vue?vue&type=script&lang=js"
export * from "./InterestAllies.vue?vue&type=script&lang=js"

import "./InterestAllies.vue?vue&type=style&index=0&id=3f069ab6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f069ab6"]])

export default __exports__